import { OrderType, inferLiteral } from "client/utils"
import * as types from "./types"


export const setSilDeviceBaseRoute = (baseDeviceRoute: string, baseSubsystemRoute: string) => ({
    type: inferLiteral(types.SIL_DEVICE_BASE_ROUTE),
    baseDeviceRoute,
    baseSubsystemRoute,
})


export const setSilDeviceList = (deviceList: types.SilDeviceList) => ({
    type: inferLiteral(types.SIL_DEVICE_LIST),
    deviceList,
})
export const setSilDeviceIds = (deviceIds: readonly number[]) => ({
    type: inferLiteral(types.SIL_DEVICE_IDS),
    deviceIds,
})
export const setSilDeviceView = (device: types.SilDeviceType) => ({
    type: inferLiteral(types.SIL_DEVICE_VIEW),
    device,
})
export const setSilDeviceEdit = (device: types.SilDeviceType) => ({
    type: inferLiteral(types.SIL_DEVICE_EDIT),
    device,
})


export const setSilDeviceNestedCurrentList = (deviceList: readonly types.SilDeviceNestedType[]) => ({
    type: inferLiteral(types.SIL_DEVICE_NESTED_CURRENT_LIST),
    deviceList,
})
export const setSilDeviceNestedNewList = (deviceList: readonly types.SilDeviceNestedType[]) => ({
    type: inferLiteral(types.SIL_DEVICE_NESTED_NEW_LIST),
    deviceList,
})


export const setSilDeviceSort = (sortColumn: keyof types.SilDeviceType, sortOrder: OrderType) => ({
    type: inferLiteral(types.SIL_DEVICE_SORT),
    sortColumn,
    sortOrder,
})
export const setSilDeviceFilters = (filters: types.SilDeviceFilters) => ({
    type: inferLiteral(types.SIL_DEVICE_FILTERS),
    filters,
})


export const setSilDeviceReloadList = (value: boolean) => ({
    type: inferLiteral(types.SIL_DEVICE_RELOAD_LIST),
    value,
})
export const setSilDeviceReloadView = (value: boolean) => ({
    type: inferLiteral(types.SIL_DEVICE_RELOAD_VIEW),
    value,
})
export const setSilDeviceReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.SIL_DEVICE_RELOAD_EDIT),
    value,
})
